import styled from "styled-components";
import { colors, device } from "../../styles/global.style";

const BannerContainer = styled.header`
  position: relative;
  background:
    linear-gradient(135deg, rgba(10, 22, 40, 0.85) 0%, rgba(10, 22, 40, 0.6) 100%),
    url(${(props) => props.bg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;

  @media (max-width: 992px) {
    background:
      linear-gradient(135deg, rgba(10, 22, 40, 0.9) 0%, rgba(10, 22, 40, 0.7) 100%),
      url(${(props) => props.mobileBg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: auto;
    min-height: 100vh;
    padding-bottom: 40px;
  }
`;

const GlowEffect = styled.div`
  position: absolute;
  top: -50%;
  right: -20%;
  width: 80%;
  height: 150%;
  background: radial-gradient(ellipse at center, rgba(245, 166, 35, 0.15) 0%, transparent 70%);
  pointer-events: none;
  animation: pulse 8s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { opacity: 0.4; transform: scale(1); }
    50% { opacity: 0.7; transform: scale(1.1); }
  }
`;

const BannerBody = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 160px;
  padding-left: 8%;
  padding-right: 8%;
  width: 90%;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;

  @media ${device.md} {
    padding-top: 140px;
    width: 75%;
  }

  @media ${device.lg} {
    padding-top: 120px;
    width: 65%;
  }
`;

const Container = styled.div`
  height: 100%;
`;

const BannerDescription = styled.p`
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.7;
  letter-spacing: -0.2px;
  color: ${colors.light};
  margin: 20px 0 32px;
  max-width: 550px;
  opacity: 0.95;

  @media ${device.md} {
    font-size: 18px;
    margin: 24px 0 40px;
  }

  @media ${device.lg} {
    font-size: 20px;
  }
`;

const Card = styled.div`
  position: relative;
  margin-right: 20px;
  top: -40px;
  background: ${colors.white};
  padding: 18px 28px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  border-left: 4px solid ${colors.primary};

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  }

  @media ${device.md} {
    margin-right: 60px;
    top: -100px;
    padding: 24px 36px;
  }
`;

const BannerHeading = styled.h1`
  font-size: 32px;
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  color: ${colors.light};
  letter-spacing: -1.5px;
  line-height: 1.1;

  @media ${device.md} {
    font-size: 48px;
    letter-spacing: -2px;
  }

  @media ${device.lg} {
    font-size: 64px;
    letter-spacing: -3px;
  }
`;

const StatsBar = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 48px;
  flex-wrap: wrap;

  @media ${device.md} {
    gap: 48px;
    margin-top: 64px;
  }
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StatNumber = styled.span`
  font-family: "Space Grotesk", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: ${colors.primary};
  line-height: 1;

  @media ${device.md} {
    font-size: 36px;
  }

  @media ${device.lg} {
    font-size: 42px;
  }
`;

const StatLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: ${colors.light};
  opacity: 0.8;
  margin-top: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media ${device.md} {
    font-size: 14px;
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  min-height: 300px;
`;

const Link = styled.a`
  text-decoration: none;
  color: ${colors.tertiary};
  &&:hover {
    color: ${colors.secondary};
  }
`;

export {
  Link,
  BannerDescription,
  Container,
  BannerImage,
  BannerContainer,
  BannerBody,
  Card,
  BannerHeading,
  StatsBar,
  StatItem,
  StatNumber,
  StatLabel,
  GlowEffect,
};
